module.exports = __webpack_public_path__ + "assets/img/xiaochengxu.fe282d41.jpg";